module.exports = __webpack_public_path__ + "img/ink.933cedd0.png";